import { Field } from 'formik'
import { TextField as _TextField } from 'formik-material-ui'
import React from 'react'

const TextField = (props) => {
  return <Field component={_TextField} {...props} />
}

export default TextField
